// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"466":"fa5d1ea0","633":"c124f354","722":"7d5aaf44","752":"94366c55","787":"fd973b67"}[chunkId] + ".chunk.js";
};